import { queryOptions } from '@tanstack/react-query';
import { PdpProgressReportDTO } from '@/types/models';
import { client } from '@/api/client';
import { pdpProgressReportMap } from '@/utils/mapper/planProgressReport';
export const getPdpProgressReport = async (id: string): Promise<PdpProgressReportDTO[]> => {
  try {
    const result = await client.get(`/plans/${id}/progress-report`);
    return pdpProgressReportMap(result.data.data || []);
  } catch (error) {
    return [];
  }
};
export const pdpProgressReportOptions = (id: string) => queryOptions({
  queryKey: ['pdp-progress-report', id],
  queryFn: () => getPdpProgressReport(id)
});